import { AwardExecutiveSummaryFileTemplate } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardExecutiveSummaryFileTemplateMetadata: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AwardExecutiveSummaryFileTemplate> = (fetchContext, awardId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/awards/${awardId}/executive-summary-file-template-metadata`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<AwardExecutiveSummaryFileTemplate>(fetchContext.errorStore, response, 'get award executive summary file template metadata'));
